import { render, staticRenderFns } from "./staffMore.vue?vue&type=template&id=6793c71c&scoped=true&"
import script from "./staffMore.vue?vue&type=script&lang=js&"
export * from "./staffMore.vue?vue&type=script&lang=js&"
import style0 from "./staffMore.vue?vue&type=style&index=0&id=6793c71c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6793c71c",
  null
  
)

export default component.exports